{
  "enums": {
    "claimStatus": {
      "draft": "ฉบับร่าง",
      "submitted": "ส่งแล้ว",
      "accepted": "รับแล้ว",
      "denied": "ถูกปฏิเสธ",
      "paid": "ชำระแล้ว"
    },
    "chargeStatus": {
      "pending": "รอดำเนินการ",
      "unbilled": "ยังไม่เรียกเก็บ",
      "posted": "ลงบัญชีแล้ว",
      "billed": "เรียกเก็บแล้ว",
      "adjusted": "ปรับปรุงแล้ว",
      "voided": "ยกเลิกแล้ว"
    },
    "statementDelivery": {
      "print": "พิมพ์",
      "email": "อีเมล",
      "both": "พิมพ์และอีเมล",
      "mail": "ไปรษณีย์"
    },
    "statementStatus": {
      "generated": "สร้างแล้ว",
      "sent": "ส่งแล้ว",
      "viewed": "ดูแล้ว"
    },
    "denialStatus": {
      "new": "ใหม่",
      "inReview": "กำลังตรวจสอบ",
      "appealing": "กำลังอุทธรณ์",
      "resolved": "แก้ไขแล้ว",
      "writtenOff": "ตัดเป็นหนี้สูญแล้ว"
    },
    "denialPriority": {
      "low": "ต่ำ",
      "medium": "ปานกลาง",
      "high": "สูง"
    },
    "claimType": {
      "professional": "วิชาชีพ",
      "institutional": "สถานพยาบาล",
      "dental": "ทันตกรรม",
      "pharmacy": "เภสัชกรรม"
    },
    "paymentMethod": {
      "cash": "เงินสด",
      "check": "เช็ค",
      "creditCard": "บัตรเครดิต",
      "debitCard": "บัตรเดบิต",
      "bankTransfer": "โอนเงินผ่านธนาคาร",
      "digitalWallet": "กระเป๋าเงินดิจิทัล",
      "insurance": "ประกัน"
    },
    "paymentSource": {
      "patient": "ผู้ป่วย",
      "insurance": "ประกันภัย",
      "thirdParty": "บุคคลที่สาม"
    }
  },
  "form": {
    "validation": {
      "patientIdRequired": "ต้องระบุรหัสผู้ป่วย",
      "encounterIdRequired": "ต้องระบุรหัสการเข้ารับบริการ",
      "payerIdRequired": "ต้องระบุรหัสผู้ชำระเงิน",
      "chargeCodeRequired": "ต้องระบุรหัสค่าบริการ",
      "unitPriceRequired": "ต้องระบุราคาต่อหน่วย",
      "amountRequired": "ต้องระบุจำนวนเงิน",
      "amountPositive": "จำนวนเงินต้องมากกว่าศูนย์",
      "chargeSelectionRequired": "เลือกค่าบริการอย่างน้อยหนึ่งรายการ"
    }
  },
  "pages": {
    "statements": {
      "title": "ใบแจ้งยอดค่ารักษา",
      "labels": {
        "dashboard": "แดชบอร์ด",
        "patient": "ผู้ป่วย",
        "from": "จาก",
        "to": "ถึง",
        "batchGenerate": "สร้างเป็นชุด",
        "previewStatement": "ดูตัวอย่างใบแจ้งยอด",
        "generatePrint": "สร้างและพิมพ์",
        "generateEmail": "สร้างและส่งอีเมล",
        "printEmail": "พิมพ์และอีเมล",
        "print": "พิมพ์",
        "email": "อีเมล"
      },
      "placeholders": {
        "searchPatient": "ค้นหาด้วยชื่อหรือ MRN..."
      },
      "aria": {
        "periodFrom": "ช่วงใบแจ้งยอดจาก",
        "periodTo": "ช่วงใบแจ้งยอดถึง"
      },
      "table": {
        "header": {
          "statementHistory": "ประวัติใบแจ้งยอด",
          "patient": "ผู้ป่วย",
          "mrn": "MRN",
          "date": "วันที่",
          "amount": "จำนวนเงิน",
          "delivery": "การจัดส่ง",
          "status": "สถานะ"
        },
        "preview": {
          "modal": "ดูตัวอย่างใบแจ้งยอด",
          "patientStatement": "ใบแจ้งยอดผู้ป่วย",
          "patient": "ผู้ป่วย:",
          "mrn": "MRN:",
          "statementDate": "วันที่ใบแจ้งยอด:",
          "period": "ช่วงเวลา:",
          "lineItemHeader": {
            "date": "วันที่",
            "description": "รายละเอียด",
            "charges": "ค่าใช้จ่าย",
            "payments": "การชำระเงิน",
            "balance": "ยอดคงเหลือ"
          },
          "openingBalance": "ยอดยกมา",
          "totals": "รวม",
          "amountDue": "จำนวนเงินที่ต้องชำระ"
        }
      },
      "states": {
        "generating": "กำลังสร้าง...",
        "loading": "กำลังสร้างตัวอย่าง...",
        "noPatients": "ไม่พบผู้ป่วย",
        "noStatementData": "ไม่มีข้อมูลใบแจ้งยอด",
        "loadingHistory": "กำลังโหลดประวัติ...",
        "noStatementsGenerated": "ยังไม่มีการสร้างใบแจ้งยอด",
        "selectedPatientId": "รหัสผู้ป่วยที่เลือก: {{id}}"
      },
      "toast": {
        "generated": "สร้างใบแจ้งยอดแล้ว",
        "generatedError": "สร้างใบแจ้งยอดไม่สำเร็จ",
        "batchStarted": "เริ่มสร้างเป็นชุดแล้ว: ใบแจ้งยอด {{count}} รายการอยู่ในคิว",
        "batchError": "เริ่มสร้างเป็นชุดไม่สำเร็จ"
      }
    },
    "claims": {
      "title": "การจัดการเคลม",
      "labels": {
        "dashboard": "แดชบอร์ด",
        "createClaim": "สร้างเคลม",
        "filters": "ตัวกรอง",
        "submit": "ส่ง",
        "appeal": "อุทธรณ์",
        "denialReason": "เหตุผลการปฏิเสธ",
        "expandHint": "ขยายเคลมเพื่อดูรายการในหน้าเคลมเฉพาะ",
        "cancel": "ยกเลิก"
      },
      "filter": {
        "allStatuses": "ทุกสถานะ"
      },
      "placeholders": {
        "filterPayer": "กรองตามผู้ชำระเงิน..."
      },
      "aria": {
        "claimDateFrom": "วันที่เคลมตั้งแต่",
        "claimDateTo": "วันที่เคลมถึง"
      },
      "table": {
        "header": {
          "claimNumber": "เคลม #",
          "patient": "ผู้ป่วย",
          "payer": "ผู้ชำระเงิน",
          "total": "รวม",
          "status": "สถานะ",
          "submitted": "ส่งแล้ว",
          "actions": "การดำเนินการ"
        }
      },
      "modal": {
        "createClaim": "สร้างเคลมจากค่าใช้จ่าย",
        "patientId": "รหัสผู้ป่วย *",
        "payerId": "รหัสผู้ชำระเงิน *",
        "selectCharges": "เลือกค่าใช้จ่าย (เลือก {{selected}} รายการ)",
        "noBilledCharges": "ไม่มีค่าใช้จ่ายที่ยังไม่ได้เรียกเก็บสำหรับผู้ป่วยรายนี้"
      },
      "states": {
        "loading": "กำลังโหลดเคลม...",
        "noClaims": "ไม่พบเคลม",
        "creating": "กำลังสร้าง..."
      },
      "toast": {
        "created": "สร้างเคลมแล้ว",
        "createdError": "สร้างเคลมไม่สำเร็จ",
        "submitted": "ส่งเคลมแล้ว",
        "submittedError": "ส่งเคลมไม่สำเร็จ",
        "resubmitted": "ส่งเคลมอีกครั้งเพื่ออุทธรณ์",
        "resubmittedError": "ส่งเคลมอีกครั้งไม่สำเร็จ",
        "patientPayerRequired": "ต้องระบุผู้ป่วยและผู้ชำระเงิน",
        "chargeRequired": "เลือกค่าใช้จ่ายอย่างน้อยหนึ่งรายการ"
      }
    },
    "charges": {
      "title": "การจัดการค่าใช้จ่าย",
      "labels": {
        "dashboard": "แดชบอร์ด",
        "newCharge": "ค่าใช้จ่ายใหม่",
        "totalChargesPeriod": "ค่าใช้จ่ายรวม (ช่วงเวลา)",
        "filters": "ตัวกรอง",
        "cancel": "ยกเลิก"
      },
      "filter": {
        "allStatuses": "ทุกสถานะ"
      },
      "placeholders": {
        "filterPatient": "กรองตามผู้ป่วย..."
      },
      "aria": {
        "serviceDateFrom": "วันที่ให้บริการตั้งแต่",
        "serviceDateTo": "วันที่ให้บริการถึง"
      },
      "table": {
        "header": {
          "date": "วันที่",
          "patient": "ผู้ป่วย",
          "encounter": "การเข้ารับบริการ",
          "code": "รหัส",
          "description": "รายละเอียด",
          "qty": "จำนวน",
          "unitPrice": "ราคาต่อหน่วย",
          "total": "รวม",
          "status": "สถานะ",
          "actions": "การดำเนินการ"
        }
      },
      "actions": {
        "void": "ยกเลิก"
      },
      "modal": {
        "voidCharge": "ยกเลิกค่าใช้จ่าย",
        "voidChargeConfirm": "ยกเลิกค่าใช้จ่าย {{code}} - {{description}} ({{amount}}) หรือไม่?",
        "reason": "เหตุผล *",
        "reasonPlaceholder": "ป้อนเหตุผลในการยกเลิก..."
      },
      "states": {
        "loading": "กำลังโหลดค่าใช้จ่าย...",
        "noCharges": "ไม่พบค่าใช้จ่ายสำหรับช่วงเวลานี้",
        "voiding": "กำลังยกเลิก..."
      },
      "toast": {
        "voided": "ยกเลิกค่าใช้จ่ายแล้ว",
        "voidedError": "ยกเลิกค่าใช้จ่ายไม่สำเร็จ",
        "reasonRequired": "ต้องระบุเหตุผล"
      }
    },
    "payments": {
      "title": "การลงรายการชำระเงิน",
      "labels": {
        "dashboard": "แดชบอร์ด",
        "uploadEraEob": "อัปโหลด ERA/EOB",
        "postPayment": "ลงรายการชำระเงิน",
        "totalPaymentsPeriod": "ยอดชำระเงินรวม (ช่วงเวลา)",
        "filters": "ตัวกรอง",
        "cancel": "ยกเลิก"
      },
      "placeholders": {
        "filterPatient": "กรองตามผู้ป่วย..."
      },
      "aria": {
        "paymentDateFrom": "วันที่ชำระเงินตั้งแต่",
        "paymentDateTo": "วันที่ชำระเงินถึง"
      },
      "table": {
        "header": {
          "date": "วันที่",
          "patient": "ผู้ป่วย",
          "claimNumber": "เคลม #",
          "amount": "จำนวนเงิน",
          "method": "วิธีการ",
          "reference": "อ้างอิง",
          "postedBy": "ลงรายการโดย"
        }
      },
      "modal": {
        "postPayment": "ลงรายการชำระเงิน",
        "patientId": "รหัสผู้ป่วย *",
        "claimId": "รหัสเคลม (ไม่บังคับ)",
        "claimIdHint": "เว้นว่างไว้สำหรับการชำระเงินที่ยังไม่ได้ใช้",
        "amount": "จำนวนเงิน *",
        "method": "วิธีการ *",
        "referenceNumber": "หมายเลขอ้างอิง",
        "referenceHint": "หมายเลขเช็ค รหัสธุรกรรม ฯลฯ",
        "notes": "หมายเหตุ"
      },
      "states": {
        "loading": "กำลังโหลดการชำระเงิน...",
        "noPayments": "ไม่พบการชำระเงินสำหรับช่วงเวลานี้",
        "posting": "กำลังลงรายการ..."
      },
      "toast": {
        "posted": "ลงรายการชำระเงินสำเร็จ",
        "postedError": "ลงรายการชำระเงินไม่สำเร็จ",
        "patientAmountRequired": "ต้องระบุผู้ป่วยและจำนวนเงิน",
        "validAmount": "โปรดป้อนจำนวนเงินที่ถูกต้อง",
        "eraEobSoon": "การอัปโหลด ERA/EOB กำลังจะมา"
      }
    },
    "chargeForm": {
      "title": "สร้างค่าบริการ",
      "labels": {
        "patientId": "รหัสผู้ป่วย *",
        "encounterId": "รหัสการเข้ารับบริการ *",
        "chargeCode": "รหัสค่าบริการ *",
        "description": "รายละเอียด",
        "cptCode": "รหัส CPT",
        "quantity": "จำนวน *",
        "unitPrice": "ราคาต่อหน่วย *"
      },
      "placeholders": {
        "chargeCode": "ค้นหามาสเตอร์ค่าบริการ...",
        "cptCode": "ค้นหารหัสหัตถการ CPT..."
      },
      "buttons": {
        "cancel": "ยกเลิก",
        "create": "สร้างค่าบริการ"
      },
      "toast": {
        "created": "สร้างค่าบริการแล้ว",
        "createdError": "ไม่สามารถสร้างค่าบริการได้"
      }
    },
    "claimForm": {
      "title": "สร้างเคลม",
      "labels": {
        "patientId": "รหัสผู้ป่วย *",
        "encounterId": "รหัสการเข้ารับบริการ *",
        "payerId": "รหัสผู้ชำระเงิน *",
        "claimType": "ประเภทเคลม *",
        "diagnosisCodes": "รหัสการวินิจฉัย",
        "selectCharges": "เลือกค่าใช้จ่าย (เลือก {{selected}} รายการ)",
        "notes": "หมายเหตุ"
      },
      "placeholders": {
        "diagnosisCodes": "รหัส ICD-10 คั่นด้วยจุลภาค (เช่น J06.9, R05)"
      },
      "buttons": {
        "cancel": "ยกเลิก",
        "create": "สร้างเคลม"
      },
      "toast": {
        "created": "สร้างเคลมแล้ว",
        "createdError": "สร้างเคลมไม่สำเร็จ"
      }
    },
    "paymentForm": {
      "title": "ลงรายการชำระเงิน",
      "labels": {
        "patientId": "รหัสผู้ป่วย *",
        "claimId": "รหัสเคลม",
        "amount": "จำนวนเงิน *",
        "method": "วิธีการชำระเงิน *",
        "source": "แหล่งที่มา",
        "referenceNumber": "หมายเลขอ้างอิง",
        "notes": "หมายเหตุ"
      },
      "placeholders": {
        "claimId": "ไม่บังคับ — เชื่อมโยงกับเคลม",
        "reference": "อ้างอิงธุรกรรมหรือเช็ค"
      },
      "buttons": {
        "cancel": "ยกเลิก",
        "post": "ลงรายการชำระเงิน"
      },
      "toast": {
        "recorded": "บันทึกการชำระเงินแล้ว",
        "recordedError": "บันทึกการชำระเงินไม่สำเร็จ"
      }
    },
    "denials": {
      "title": "การจัดการการปฏิเสธ",
      "subtitle": "ติดตามและจัดการการปฏิเสธการเรียกร้องค่าสินไหม",
      "placeholders": {
        "search": "ค้นหาการเรียกร้อง..."
      },
      "filter": {
        "all": "ทั้งหมด"
      },
      "checkbox": {
        "assignedToMe": "มอบหมายให้ฉัน"
      },
      "table": {
        "header": {
          "claimNumber": "เลขที่การเรียกร้อง",
          "patient": "ผู้ป่วย",
          "denialCode": "รหัสการปฏิเสธ",
          "denialReason": "เหตุผลการปฏิเสธ",
          "amount": "จำนวนเงิน",
          "daysRemaining": "วันที่เหลือ",
          "status": "สถานะ",
          "assignedTo": "มอบหมายให้",
          "actions": "การดำเนินการ"
        }
      },
      "actions": {
        "review": "ตรวจสอบ",
        "appeal": "อุทธรณ์",
        "writeOff": "ตัดหนี้สูญ",
        "cancel": "ยกเลิก"
      },
      "modal": {
        "appealReason": "เหตุผลการอุทธรณ์",
        "appealPlaceholder": "อธิบายเหตุผลการอุทธรณ์...",
        "submitAppeal": "ส่งการอุทธรณ์",
        "writeOffTitle": "ตัดหนี้สูญการปฏิเสธ",
        "writeOffConfirm": "คุณแน่ใจหรือไม่ว่าต้องการตัดหนี้สูญการเรียกร้อง {{claimNumber}} จำนวน {{amount}}? การดำเนินการนี้ไม่สามารถยกเลิกได้",
        "writeOffButton": "ตัดหนี้สูญ"
      },
      "states": {
        "loading": "กำลังโหลดการปฏิเสธ...",
        "noDenials": "ไม่พบการปฏิเสธ",
        "submitting": "กำลังส่ง..."
      },
      "toast": {
        "updateError": "อัปเดตสถานะการปฏิเสธไม่สำเร็จ",
        "movedToReview": "การเรียกร้อง {{claimNumber}} ถูกย้ายไปตรวจสอบ",
        "appealSubmitted": "ส่งการอุทธรณ์แล้ว",
        "writtenOff": "การเรียกร้อง {{claimNumber}} ถูกตัดหนี้สูญ"
      }
    }
  },
  "__review_denialReason": "Backend payer-authored — Phase 9, do not translate",
  "__review_denialCode": "Backend payer-authored — Phase 9, do not translate",
  "__review_chargeDescription": "Backend payer-authored — Phase 9, do not translate",
  "__review_chargeCode": "Backend payer-authored — Phase 9, do not translate"
}
